module.exports = __webpack_public_path__ + "img/zuijia_42.465c72ca.png";